// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_ACCESSIBILITY_LABELS = 'global.accessibility';

export const accountIconButton = 'accountIconButton';
export const brandSwitchModalDescriptionTxt = 'brand_switch_modal_description_txt';
export const brandSwitchModalGotItTxt = 'brand_switch_modal_got_it_txt';
export const brandSwitchTutorialDescriptionTxt = 'brand_switch_tutorial_description_txt';
export const brandSwitchTutorialGotItTxt = 'brand_switch_tutorial_got_it_txt';
export const brandSwitchTutorialHeaderTxt = 'brand_switch_tutorial_header_txt';
export const carouselDescription = 'carouselDescription';
export const cartIconButton = 'cartIconButton';
export const closeIconButton = 'closeIconButton';
export const condensedNavigationAriaLabel = 'condensed_navigation_aria_label';
export const exitCheckout = 'exit_checkout';
export const favoriteIconButton = 'favoriteIconButton';
export const gymboreeLink = 'gymboreeLink';
export const hamburgerMenu = 'hamburgerMenu';
export const lblAccessibilityBackButton = 'lbl_accessibility_backButton';
export const lblBackButton = 'lbl_back_button';
export const lblBrandSwitch = 'lbl_brand_switch';
export const lblBrandlogoSnjAltText = 'lbl_brandlogo_snjAltText';
export const lblBrandlogoTcpAltText = 'lbl_brandlogo_tcpAltText';
export const lblCaretIcon = 'lbl_caret_icon';
export const lblCreateAccountTermsConditionsAppAccessibilityText =
  'lbl_createAccount_termsConditions_app_accessibilityText';
export const lblDownArrowIcon = 'lbl_down_arrow_icon';
export const lblFastShipping = 'lbl_fast_shipping';
export const lblInfoIcon = 'lbl_info_icon';
export const lblOutOf = 'lbl_out_of';
export const lblOutfitImage = 'lbl_outfit_image';
export const lblPasswordTooltip = 'lbl_password_tooltip';
export const lblPickupIcon = 'lbl_pickup_icon';
export const lblPreviousPrice = 'lbl_previous_price';
export const lblPrintIcon = 'lbl_print_icon';
export const lblProductHint = 'lbl_product_hint';
export const lblProductImage = 'lbl_product_image';
export const lblRating = 'lbl_rating';
export const lblRightArrow = 'lbl_right_arrow';
export const lblSampleReceipt = 'lbl_sample_receipt';
export const lblShippingIcon = 'lbl_shipping_icon';
export const lblShowPage = 'lbl_show_page';
export const lblSocialFacebook = 'lbl_social_facebook';
export const lblSocialInstagram = 'lbl_social_instagram';
export const lblSocialPinterest = 'lbl_social_pinterest';
export const lblSocialTwitter = 'lbl_social_twitter';
export const lblUpArrowIcon = 'lbl_up_arrow_icon';
export const lblVenmoIcon = 'lbl_venmo_icon';
export const myPlaceRewards = 'my_place_rewards';
export const nextIconButton = 'nextIconButton';
export const pauseIconButton = 'pauseIconButton';
export const playIconButton = 'playIconButton';
export const previousButton = 'previousButton';
export const searchIconButton = 'searchIconButton';
export const skipNavigation = 'skipNavigation';
export const theChildrensplace = 'theChildrensplace';
export const lblMarkerIcon = 'lbl_marker_icon';

export const GlobalAccessibilityLabels = {
  global: {
    accessibility: {
      condensed_navigation_aria_label: 'Condensed',
      nextIconButton: 'next',
      pauseIconButton: 'pause. please click to play.',
      playIconButton: 'play. please click to pause.',
      previousButton: 'Previous',
      lbl_tick_icon: 'tick icon',
      lbl_plus_icon: 'plus icon',
      [accountIconButton]: 'account',
      [brandSwitchModalDescriptionTxt]:
        'Wherever and whenever our customers choose to shop with us, they trust The  Children’s Place, Gymboree, Sugar & Jade and PJ Place to provide quality, value and  style. Choose a brand below and start shopping.',
      [brandSwitchModalGotItTxt]: 'Got it',
      [brandSwitchTutorialDescriptionTxt]:
        'Press the logo anytime to explore and shop them, all while using the same cart.',
      [brandSwitchTutorialGotItTxt]: 'Got it!',
      [brandSwitchTutorialHeaderTxt]: 'Want to explore our other brands?',
      [carouselDescription]: 'Carousel',
      [cartIconButton]: 'cart',
      [closeIconButton]: 'close',
      [condensedNavigationAriaLabel]: 'Condensed',
      [exitCheckout]: 'Exit checkout',
      [favoriteIconButton]: 'Favorite',
      [gymboreeLink]: 'Gymboree Link',
      [hamburgerMenu]: 'hamburger menu',
      [lblAccessibilityBackButton]: 'Click To go back',
      [lblBackButton]: 'back button',
      [lblBrandSwitch]: 'Brand Switch',
      [lblBrandlogoSnjAltText]: 'Sugar and Jade',
      [lblBrandlogoTcpAltText]: 'The Childrens Place',
      [lblCaretIcon]: 'Exit from checkout',
      [lblCreateAccountTermsConditionsAppAccessibilityText]:
        'I agree to the My Place Rewards Terms & Conditions and Privacy Policy of the My Place Rewards Program, and I understand that I will receive marketing communications from The Children’s Place, including email and direct mail. I agree to provide certain personal information for use by The Children’s Place in connection with the My Place Rewards Program. I can withdraw my consent at any time to receive marketing emails or to The Children’s Place’s use of my personal information in connection with the My Place Rewards Program. Contact Us',
      [lblDownArrowIcon]: 'Down arrow icon',
      [lblFastShipping]: 'Fast Shipping',
      [lblInfoIcon]: 'Info icon',
      [lblOutOf]: 'out of',
      [lblOutfitImage]: 'Outfit image',
      [lblPasswordTooltip]: 'Open Password Requirements tooltip',
      [lblPickupIcon]: 'pickup icon',
      [lblPreviousPrice]: 'Previous Price',
      [lblPrintIcon]: 'Print icon',
      [lblProductHint]: 'Pagination to show different images of the product',
      [lblProductImage]: 'of product image',
      [lblRating]: 'rating',
      [lblRightArrow]: 'right arrow',
      [lblSampleReceipt]: 'Sample Receipt',
      [lblShippingIcon]: 'shipping icon',
      [lblShowPage]: 'shows page',
      [lblSocialFacebook]: 'facebook',
      [lblSocialInstagram]: 'instagram icon',
      [lblSocialPinterest]: 'pinterest',
      [lblSocialTwitter]: 'twitter',
      [lblUpArrowIcon]: 'Up arrow Icon',
      [lblVenmoIcon]: 'venmo-logo',
      [myPlaceRewards]: 'My Place Rewards',
      [searchIconButton]: 'search',
      [skipNavigation]: 'skip to main content',
      [theChildrensplace]: 'The Childrens Place Link',
    },
  },
};
